import { Phone, Mail, Globe, MapPin } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";

const people = [
  {
    name: "Bhanu Mahajan",
    first: "Bhanu",
    last: "Mahajan",
    phone: "+91-9871737737",
    tel: "+919871737737",
    email: "bhanu@metalix-xt.com",
  },
  {
    name: "Jay Kumar Agrawal",
    first: "Jay Kumar",
    last: "Agrawal",
    phone: "+91-9007407250",
    tel: "+919007407250",
    email: "jay@metalix-xt.com",
  },
];

const WEB = "www.metalix-xt.com";
const ADDR = "6th Floor, Block B, 50 Chowringhee Road, Kolkata - 700071";

const vcard = (p) =>
  [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${p.last};${p.first};;;`,
    `FN:${p.name}`,
    "ORG:Metalix XT Pvt Ltd",
    `TEL;TYPE=CELL:${p.tel}`,
    `EMAIL:${p.email}`,
    "URL:https://www.metalix-xt.com",
    "ADR;TYPE=WORK:;;6th Floor Block B 50 Chowringhee Road;Kolkata;West Bengal;700071;India",
    "END:VCARD",
  ].join("\n");

const CardFront = ({ p }) => (
  <div
    data-testid={`card-front-${p.first.split(" ")[0].toLowerCase()}`}
    className="relative flex flex-col justify-between overflow-hidden bg-[var(--mx-bg)]"
    style={{ width: 1050, height: 600, padding: 64 }}
  >
    <div className="pointer-events-none absolute right-0 top-0 h-full w-3 bg-[var(--mx-copper)]" />
    <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[var(--mx-copper)]/10 blur-3xl" />

    {/* QR code — scan to save contact */}
    <div className="absolute right-24 top-16 flex flex-col items-center gap-2">
      <div className="rounded-xl border border-[var(--mx-line)] bg-white p-2.5">
        <QRCodeSVG
          value={vcard(p)}
          size={128}
          level="H"
          fgColor="#1b1714"
          bgColor="#ffffff"
          imageSettings={{
            src: "/metalix-mark-clean.png",
            height: 30,
            width: 30,
            excavate: true,
          }}
        />
      </div>
      <span className="font-mono-tech text-[10px] uppercase tracking-widest text-[var(--mx-ink-2)]">
        Scan to save
      </span>
    </div>

    <div className="flex items-center gap-4">
      <img
        src="/metalix-mark-clean.png"
        alt="Metalix"
        style={{ height: 84 }}
        className="w-auto drop-shadow-[0_4px_14px_rgba(224,114,76,0.35)]"
      />
      <div>
        <div className="font-display text-4xl font-extrabold tracking-tight text-[var(--mx-ink)]">
          Metal<span className="text-[var(--mx-copper)]">ix</span> XT
        </div>
        <div className="flex w-full justify-between font-mono-tech text-[10px] uppercase text-[var(--mx-ink-2)]">
          {"Private Limited".split("").map((c, i) => (
            <span key={i}>{c === " " ? "\u00A0" : c}</span>
          ))}
        </div>
      </div>
    </div>

    <div>
      <div className="font-display text-5xl font-black uppercase leading-none tracking-tight text-[var(--mx-ink)]">
        {p.name}
      </div>
    </div>

    <div className="grid grid-cols-2 gap-x-8 gap-y-3 text-[var(--mx-ink)]">
      <div className="flex items-center gap-3 text-base">
        <Phone size={18} className="text-[var(--mx-copper)]" /> {p.phone}
      </div>
      <div className="flex items-center gap-3 text-base">
        <Globe size={18} className="text-[var(--mx-copper)]" /> {WEB}
      </div>
      <div className="flex items-center gap-3 text-base">
        <Mail size={18} className="text-[var(--mx-copper)]" /> {p.email}
      </div>
      <div className="flex items-start gap-3 text-[13px] leading-snug text-[var(--mx-ink-2)]">
        <MapPin size={18} className="mt-0.5 shrink-0 text-[var(--mx-copper)]" />
        {ADDR}
      </div>
    </div>
  </div>
);

const CardBack = () => (
  <div
    className="relative flex flex-col items-center justify-center overflow-hidden bg-[var(--mx-charcoal)]"
    style={{ width: 1050, height: 600, padding: 64 }}
  >
    <div className="pointer-events-none absolute -left-20 top-1/2 h-80 w-80 -translate-y-1/2 rounded-full bg-[var(--mx-copper)]/25 blur-[90px]" />
    <div className="pointer-events-none absolute -right-20 top-1/3 h-72 w-72 rounded-full bg-[var(--mx-teal)]/20 blur-[90px]" />
    <img
      src="/metalix-mark-clean.png"
      alt="Metalix"
      style={{ height: 150 }}
      className="relative z-10 w-auto drop-shadow-[0_6px_28px_rgba(224,114,76,0.5)]"
    />
    <div className="relative z-10 mt-6 font-display text-6xl font-black uppercase tracking-tight text-[#f6f2ec]">
      Metal<span className="text-[var(--mx-copper-soft)]">ix</span> XT
    </div>
    <div className="relative z-10 mt-4 font-mono-tech text-xs uppercase tracking-[0.4em] text-[var(--mx-copper-soft)]">
      Non-Ferrous Recycling · Circular Metals
    </div>
    <div className="relative z-10 mt-8 font-mono-tech text-xs uppercase tracking-widest text-[#c9c2ba]">
      {WEB}
    </div>
  </div>
);

export default function BusinessCards() {
  return (
    <div className="cards-page relative z-50 min-h-screen bg-[var(--mx-surface-2)] px-6 py-16 md:px-10">
      <div className="mx-auto max-w-[1200px]">
        <div className="no-print mb-10 flex items-center justify-between">
          <div>
            <h1 className="font-display text-3xl font-black uppercase tracking-tight text-[var(--mx-ink)]">
              Business Cards
            </h1>
            <p className="mt-1 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-2)]">
              Standard 3.5&quot; × 2&quot; · prints one card per page (front &amp; back)
            </p>
          </div>
          <button
            data-testid="print-cards"
            onClick={() => window.print()}
            className="rounded-full bg-[var(--mx-copper)] px-6 py-3 font-mono-tech text-xs uppercase tracking-widest text-white"
          >
            Print / Save PDF
          </button>
        </div>

        <div className="no-print mb-12 flex flex-wrap items-center gap-3">
          <span className="mr-1 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-2)]">
            Brand assets:
          </span>
          <a
            download="metalix-logo-mark.png"
            href="/metalix-mark-clean.png"
            data-testid="download-mark-png"
            className="rounded-full border border-[var(--mx-line-strong)] px-4 py-2 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink)] transition-colors hover:border-[var(--mx-copper)] hover:text-[var(--mx-copper)]"
          >
            Logo mark ↓ PNG
          </a>
          <a
            download="metalix-logo-full.jpg"
            href="/metalix-logo.jpeg"
            data-testid="download-logo-full"
            className="rounded-full border border-[var(--mx-line-strong)] px-4 py-2 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink)] transition-colors hover:border-[var(--mx-copper)] hover:text-[var(--mx-copper)]"
          >
            Full logo ↓ JPG
          </a>
          <a
            download="metalix-logo-animation.mp4"
            href="/metalix-logo.mp4"
            data-testid="download-logo-video"
            className="rounded-full border border-[var(--mx-line-strong)] px-4 py-2 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink)] transition-colors hover:border-[var(--mx-copper)] hover:text-[var(--mx-copper)]"
          >
            Animation ↓ MP4
          </a>
          <span className="ml-2 mr-1 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-2)]">
            Editable source:
          </span>
          <a
            download="Metalix-Card-Bhanu-Mahajan.svg"
            href="/card-bhanu.svg"
            data-testid="download-card-bhanu"
            className="rounded-full border border-[var(--mx-copper)] bg-[var(--mx-copper)]/10 px-4 py-2 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-copper)] transition-colors hover:bg-[var(--mx-copper)] hover:text-white"
          >
            Bhanu ↓ SVG
          </a>
          <a
            download="Metalix-Card-Jay-Kumar-Agrawal.svg"
            href="/card-jay.svg"
            data-testid="download-card-jay"
            className="rounded-full border border-[var(--mx-copper)] bg-[var(--mx-copper)]/10 px-4 py-2 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-copper)] transition-colors hover:bg-[var(--mx-copper)] hover:text-white"
          >
            Jay ↓ SVG
          </a>
          <a
            download="Metalix-Card-Back.svg"
            href="/card-back.svg"
            data-testid="download-card-back"
            className="rounded-full border border-[var(--mx-copper)] bg-[var(--mx-copper)]/10 px-4 py-2 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-copper)] transition-colors hover:bg-[var(--mx-copper)] hover:text-white"
          >
            Card back ↓ SVG
          </a>
          <span className="ml-2 mr-1 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-2)]">
            Press-ready (CMYK · bleed · crop marks):
          </span>
          <a
            download="Metalix-Card-Bhanu-Mahajan-Print.pdf"
            href="/card-bhanu-print.pdf"
            data-testid="download-card-bhanu-pdf"
            className="rounded-full border border-[var(--mx-charcoal)] bg-[var(--mx-charcoal)] px-4 py-2 font-mono-tech text-xs uppercase tracking-widest text-white transition-colors hover:bg-[var(--mx-copper)]"
          >
            Bhanu ↓ PDF
          </a>
          <a
            download="Metalix-Card-Jay-Kumar-Agrawal-Print.pdf"
            href="/card-jay-print.pdf"
            data-testid="download-card-jay-pdf"
            className="rounded-full border border-[var(--mx-charcoal)] bg-[var(--mx-charcoal)] px-4 py-2 font-mono-tech text-xs uppercase tracking-widest text-white transition-colors hover:bg-[var(--mx-copper)]"
          >
            Jay ↓ PDF
          </a>
        </div>

        <div className="space-y-16">
          {people.map((p) => (            <div key={p.name}>
              <div className="no-print mb-4 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-2)]">
                {p.name}
              </div>
              <div className="flex flex-wrap gap-8">
                <div className="card-print overflow-hidden rounded-2xl shadow-[0_30px_80px_-40px_rgba(27,23,20,0.5)] ring-1 ring-[var(--mx-line)]">
                  <CardFront p={p} />
                </div>
                <div className="card-print overflow-hidden rounded-2xl shadow-[0_30px_80px_-40px_rgba(27,23,20,0.5)] ring-1 ring-[var(--mx-line)]">
                  <CardBack />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
